import { EntityId } from '@reduxjs/toolkit';
import { paymentTypeEntityAdapter } from './payment-type.slice';
import { RootState } from '../../../_config/redux';

const paiementSelector = paymentTypeEntityAdapter.getSelectors<RootState>((state) => state.paymentType);

export const selectPaymentTypeById = (id: EntityId) => (state: RootState) => paiementSelector.selectById(state, id);

export const selectAllPaymentTypes = (state: RootState) => paiementSelector.selectAll(state);